import {Route, Routes} from "react-router-dom";
import List from "./List";
import {RouterProps} from "../../../RouterProps";
import Detail from "./Detail";
import ReasonRouter from "./reason/ReasonRouter";

export default function ReportRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/:contentCommentReportId'} element={<Detail {...props} />} />
            <Route path={'/reasons/*'} element={<ReasonRouter {...props} />} />
        </Routes>
    </>
}